import AnimatedCursor from "react-animated-cursor";
import "./App.scss";
import Router from "./Routes/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Make sure the CSS is imported globally
import Chat from "./Chat";

function App() {
  // remove all console logs
  console.log = function () {};

  return (
    <div className="App">
      <AnimatedCursor
        innerSize={8}
        outerSize={32}
        color="13, 86, 235"
        outerAlpha={0.4}
        innerScale={1}
        outerScale={2}
        zIndex={9999}
        clickables={[
          "a",
          "button",
          ".clickable",
          ".tabinationButton ",
          ".navbarKey  ",
          ".pfPImage",
          ".arrow-icon",
          ".expanded",
          ".platform_box",
          ".ac_type_option",
          ".amount_box",
          ".arrow_icon",
          ".discordMediaSection",
          ".instaMediaSection",
          ".youtubeMediaSection",
          ".twitterMediaSection",
          ".PrivateSwitchBase-input",
          ".navbar_content",
          ".policiesSection ",
          ".companyTitle",
          ".ant-segmented-item ",
          ".dot ",
          ".paymentMethods",
          "customerInfo_",
          ".trustPilotRatingBtn",
          ".blogBox",
        ]}
      />
      <Router />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeButton={true}
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
      <Chat />
    </div>
  );
}

export default App;
